// extracted by mini-css-extract-plugin
module.exports = {"current-price-line":"CurrentPriceLine_current-price-line__YoYdJ","current-price-circle":"CurrentPriceLine_current-price-circle__24w2o"};